<!--
 * @Author: TCS
 * @Date: 2020-04-08 10:50:52
 * @LastEditors: DQL
 * @LastEditTime: 2022-09-29 14:36:58
 * @Description: file content
 -->
<template>
  <div
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        class="c-page__header-title"
      >
        日志审计
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <el-button
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        >
          查询
        </el-button>
        <el-button
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        >
          重置
        </el-button>
        <!-- <el-button
          type="primary"
          icon="kestrel-icon ki-export"
          plain
          :disabled="page.rows.length<1"
          @click="handleExport()"
        >
          导出
        </el-button>
        <el-button
          type="primary"
          icon="kestrel-icon ki-cloud-download"
          plain
          @click="handleDialog('export')"
        >
          下载日志
        </el-button> -->
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :rules="filterParamsRules"
          :inline="true"
          label-position="right"
          label-width="120px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="IP地址"
                prop="ipAddress"
              >
                <el-input
                  v-model.trim="filterParams.ipAddress"
                  class="c-form__input"
                  placeholder="IP地址"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="用户名"
                prop="userName"
              >
                <el-input
                  v-model.trim="filterParams.userName"
                  class="c-form__input"
                  placeholder="用户名"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="操作类型"
                prop="operateType"
              >
                <el-select
                  v-model="filterParams.operateType"
                  class="c-form__select"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item,index) in operateTypes"
                    :key="index"
                    :label="item.text"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="操作结果"
                prop="operateResult"
              >
                <!-- <el-radio
                  v-model="filterParams.operateResult"
                  class="c-form__radio"
                  label
                >
                  全部
                </el-radio>
                <el-radio
                  v-model="filterParams.operateResult"
                  class="c-form__radio"
                  label="成功"
                >
                  成功
                </el-radio>
                <el-radio
                  v-model="filterParams.operateResult"
                  class="c-form__radio"
                  label="失败"
                >
                  失败
                </el-radio> -->
                <el-radio-group
                  v-model="filterParams.operateResult"
                  class="c-form__radio-group"
                >
                  <el-radio
                    :label="null"
                  >
                    全部
                  </el-radio>
                  <el-radio
                    label="成功"
                  >
                    成功
                  </el-radio>
                  <el-radio
                    label="失败"
                  >
                    失败
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="查询日期起"
                prop="cxrqq"
              >
                <el-date-picker
                  v-model="filterParams.cxrqq"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="查询日期止"
                prop="cxrqz"
              >
                <el-date-picker
                  v-model="filterParams.cxrqz"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <div
            class="c-page__pTable"
          >
            <!-- table的ref的命名根据业务名称修改 -->
            <el-table
              ref="listTable"
              class="c-page__table o-header-text-center"
              height="100%"
              stripe
              border
              highlight-current-row
              tooltip-effect="dark"
              :data="page.rows"
              :class="{ 'o-table-empty-center': page.rows.length <= 0 }"
            >
              <el-table-column
                type="index"
                label="序号"
                width="40"
                align="center"
              />
              <el-table-column
                prop="userName"
                label="用户名"
                width="120"
                show-overflow-tooltip
              />
              <el-table-column
                prop="ipAddress"
                label="IP地址"
                show-overflow-tooltip
              />
              <el-table-column
                prop="operateTypeName"
                label="操作类型"
                width="120"
                align="center"
                show-overflow-tooltip
              />
              <el-table-column
                prop="operateName"
                label="操作名称"
                width="300"
                show-overflow-tooltip
              />
              <el-table-column
                prop="operateResult"
                label="操作结果"
                show-overflow-tooltip
              />
              <el-table-column
                prop="operateTime"
                label="操作时间"
                width="140"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.operateTime | date('yyyy-MM-dd HH:mm:ss') }}
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="c-page__pagination"
              :disabled="page.total<=0||loading"
              :page-size="page.pageSize"
              :total="page.total"
              :current-page="page.pageNo"
              layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[15,20,30]"
              @size-change="handleSizeChange"
              @current-change="search"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页面主内容：查询列表 End -->

    <!-- 导出 -->
    <export-dialog
      v-if="showDialogName==='export'"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    />
  </div>
</template>

<script>
import { logService } from './log.service.js';
import exportDialog from './exportDialog.vue';

export default {
  name: 'LogList',
  components: { exportDialog },
  data () {
    return {
      loading: false, // 页面是否loading状态

      /* 查询条件（页面绑定的查询条件） Start */
      filterParams: {
        ipAddress: null,
        userName: null,
        operateType: null,
        operateResult: null,
        // 时间范围是当前天到上个月的相同日期
        cxrqq: new Date(new Date().toLocaleDateString()).setMonth((new Date().getMonth() - 1)),
        cxrqz: new Date(new Date().toLocaleDateString()).getTime()
      },
      /* 查询条件 End */

      /* 表单校验规则 Start */
      filterParamsRules: {
        cxrqq: [
          this.$validUtils.required('查询日期起'),
          this.$HMValidator.startTime(this, 'filterParams', 'cxrqz', ['查询日期起', '查询日期止'])
        ],
        cxrqz: [
          this.$validUtils.required('查询日期止'),
          this.$HMValidator.endTime(this, 'filterParams', 'cxrqq', ['查询日期起', '查询日期止'])
        ]
      },
      /* 表单校验规则 End */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 导出实际查询条件（避免查询条件的双向绑定导致点击导出按钮，获取到的数据与查询结果不一致） Start */
      exportFilterParams: {},
      /* 导出实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 End */
    };
  },
  computed: {
    // 部门类型
    operateTypes () {
      const enums = this.$HMStoreService.getEnums();
      if (enums && enums.LOG_OPERATE_TYPE) {
        return enums.LOG_OPERATE_TYPE;
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @param {*}
     * @return {*}
     */
    refreshSearch () {
      this.$refs.filterParams.validate((valid) => {
        if (valid) {
          this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));

          /* 后台日期接收参数改为 Start */
          this.trueFilterParams.cxrqqStr = this.filterParams.cxrqq;
          this.trueFilterParams.cxrqzStr = this.filterParams.cxrqz;
          /* 后台日期接收参数改为 End */

          /* 后台日期接收参数不能接收，删除字段 Start */
          delete this.trueFilterParams.cxrqq;
          delete this.trueFilterParams.cxrqz;
          /* 后台日期接收参数不能接收，删除字段 End */

          this.search();
        }
      });
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      logService.list(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);

          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询日志出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置表单
     * @param {*}
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
     * @description: 导出
     * @param {*}
     * @return {*}
     */
    handleExport () {
      this.loading = true;
      logService.export(this.exportFilterParams)
        .then((rsp) => {
          const fileStream = rsp.data;
          const fileName = decodeURI(rsp.headers['content-disposition'].split('=')[1]);
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('下载日志出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _params) {
      this.showDialogName = _name;
      this.dialogParams = _params;
    }
  }
};

</script>
